import styled from 'styled-components';
import { Switch } from '@mui/material';
import { theme } from '../../styles/theme';
export const Wrapper = styled(Switch) `
  && {
    .Mui-checked {
      color: ${theme.colors.buttonBackgroundDefault};

      & + .MuiSwitch-track {
        background: ${theme.colors.buttonBackgroundDefault};
      }
    }
  }
`;
